import * as React           from 'react';

import { Label,
         Container,
         ButtonVariants,
         button_variants  } from 'src/components/common/button/ui';



type Props = {
  variant: ButtonVariants;
  label?: string;
  icon?: React.ReactNode;
  isDisabled?: boolean;
  onTap: () => void;
}
export const Button: React.FC<Props> = ({
  variant,
  label,
  icon,
  isDisabled = false,
  onTap
}) => {
  const lookAndFeel = button_variants.get(variant)!;
  
  const onTapHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled) {
      onTap();
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel } disabled = { isDisabled } isIcon = { icon !== undefined } onClick = { onTapHandler }>
      {label !== undefined && 
        <Label lookAndFeel = { lookAndFeel }>{ label }</Label>
      }
      {icon !== undefined && 
        icon
      }
    </Container>
  );
};
